import { render, staticRenderFns } from "./DescGoodsDialog.vue?vue&type=template&id=72ccb6df&scoped=true&lang=pug&"
import script from "./DescGoodsDialog.vue?vue&type=script&lang=ts&"
export * from "./DescGoodsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ccb6df",
  null
  
)

export default component.exports